export const STATS_MAIN_PAGE = '/*'
export const STATS_MAIN_PAGE_REDIRECT = '/statistic'
export const STATS_LOGIN = 'login'
export const STATS_LOGIN_REDIRECT = '/statistic/login'
export const STATS_DEVICE_INFO = '/device/:deviceId'
